/** @typedef {string} SelectInputToolbarPosition */
export const SELECT_INPUT_TOOLBAR_POSITION_LEFT = 'left';
export const SELECT_INPUT_TOOLBAR_POSITION_RIGHT = 'right';
/** @enum {SelectInputToolbarPosition} */
export const SELECT_INPUT_TOOLBAR_POSITION = {
	LEFT: SELECT_INPUT_TOOLBAR_POSITION_LEFT,
	RIGHT: SELECT_INPUT_TOOLBAR_POSITION_RIGHT
};
/** @type {SelectInputToolbarPosition[]} */
export const SELECT_INPUT_TOOLBAR_POSITIONS = [SELECT_INPUT_TOOLBAR_POSITION_LEFT, SELECT_INPUT_TOOLBAR_POSITION_RIGHT];